import { usePageAssets } from "hooks/usePageAssets"
import Container from "components/ui/Container"
import Heading from "components/ui/Heading"
import SplitContainer from "components/ui/Layout/SplitContainer"

function UserEngagementSection() {
  const { getAsset } = usePageAssets()
  const illustration = getAsset("customer-apps-user-engagement")
  return (
    <Container section>
      <SplitContainer
        className="py-10 lg:py-20 xl:py-32 2xl:py-40"
        image={illustration}
        imageClassName="mt-10 md:mt-0 max-w-2xl mx-auto"
        reversed
      >
        <Heading
          label="User Engagement"
          title="Increase product engagement with relevant metrics"
          subtitle={
            <>
              Let your customers gain deeper insights into business and
              operational metrics inside your application. Preset delivers
              interactive analytics capabilities in your product, enabling your
              customers to freely explore their data.
            </>
          }
          narrow
        />
      </SplitContainer>
    </Container>
  )
}

export default UserEngagementSection
